export default "@media print {\n  canvas {\n    display: none !important;\n  }\n\n  img {\n    display: block !important;\n  }\n}";